// Import React helpers
import React, { useRef, useState } from "react";

// Import portal popover
import { PortalPopover } from "global/components/PortalPopover";



// Reuse one small info icon
const InlineInfoIcon = () => (

    <svg viewBox="0 0 20 20" aria-hidden="true" focusable="false">

        <circle cx="10" cy="10" r="7.25" />

        <circle cx="10" cy="6.35" r="0.9" className="info-button__dot" />

        <path d="M10 9.15v4.35" />

    </svg>

);



// Export reusable info popover button
export const InfoButton = ({
    buttonIcon,
    settingCode,
    shortLabel,
    description,
    isOpen,
    onToggle,
    onClose,
}) => {


    // Create the button anchor reference
    const infoButtonRef = useRef(null);


    // Store the internal open state when the component is uncontrolled
    const [internalIsOpen, setInternalIsOpen] = useState(false);


    // Check whether the parent is controlling the open state
    const isControlled = typeof isOpen === "boolean";


    // Use the parent's state when controlled, otherwise use the internal state
    const resolvedIsOpen = isControlled ? isOpen : internalIsOpen;



    // Handle opening or closing the popover
    const handleToggle = () => {

        // Calculate the next open state
        const nextIsOpen = !resolvedIsOpen;



        // Call the optional parent override
        if (onToggle) {

            // Pass the setting code and the next open state to the parent
            onToggle(settingCode, nextIsOpen);

        }



        // Update internal state only when the component is uncontrolled
        if (!isControlled) {

            // Store the next open state
            setInternalIsOpen(nextIsOpen);

        }

    };



    // Handle closing the popover
    const handleClose = () => {

        // Call the optional parent close override
        if (onClose) {

            // Notify the parent that the popover is closing
            onClose(settingCode);

        } else if (onToggle) {

            // Fall back to the toggle callback when no separate close callback exists
            onToggle(settingCode, false);

        }



        // Update internal state only when the component is uncontrolled
        if (!isControlled) {

            // Close the internally controlled popover
            setInternalIsOpen(false);

        }

    };



    // Render the button and portal popover
    return (

        <>

            <button
                ref={infoButtonRef}
                type="button"
                className="info-button"
                onClick={handleToggle}
                aria-expanded={resolvedIsOpen}
                aria-label={`${shortLabel} help`}
            >

                {buttonIcon ? buttonIcon : <InlineInfoIcon />}

            </button>

            <PortalPopover
                anchorRef={infoButtonRef}
                isOpen={resolvedIsOpen}
                onClose={handleClose}
                className="info-popover"
            >

                {description}

            </PortalPopover>

        </>

    );

};

